import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  height: 60px;
  font-size: 24px;
  line-height: 60px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CommentLoader = () => (
  <Wrapper className="comment_loader">
    <img alt="preloader" src="/assets/25.gif" width="26" height="26" />
    Добавление отзыва...
  </Wrapper>
);
